/* eslint-disable */
export default {
  log: 'Protokoll',
} as const;

// @key: @#@"log"@#@ @source: @#@"Log"@#@
